var _ = require('lodash')

// var
var Helpers = {

  mapRange: function(from, to, s) {
    return to[0] + (s - from[0]) * (to[1] - to[0]) / (from[1] - from[0]);
  },
  // dec to hex
  dec2hex: function(d) {
    var h = (d).toString(16);

    if (h.length < 2) {
      return '0' + h;
    } else {
      return h;
    }
  },
  hex2dec: function(d) {
    return parseInt(d, 16);
  },
  applyFnToElements: function(elements, fn) {
    for (let i = 0; i < elements.length; ++i) {
      fn(elements[i]);
    }
  },
  getUrlParams: function (url) {
    var params = {};
    (url + '?').split('?')[1].split('&').forEach(function (pair) {
      pair = (pair + '=').split('=').map(decodeURIComponent)
      if (pair[0].length) {
        params[pair[0]] = pair[1]
      }
    })
    return params
  },
  /**
   * Converts commands which are just a list of action to a format
   * which can be used by the composers. This means that first the commands are grouped by
   * type. Identified by the first word in the key and then grouped by time because an rgb driver has
   * 2 properties per time unit. Ring one and two.

   */
  convertCommandsToRoutine: (commandsList) => {
    var commandsByType = _.groupBy(commandsList, (o) => {
      if (!o.key) return;
      let key = o.key.split('.');
      let typeKey = o.key.split('.')[0]
      return typeKey
    })
    _.forEach(commandsByType, (typeCommands, key) => {
      commandsByType[key] = _.map(_.groupBy(commandsByType[key], 'time'), (o, index) => {
        return {
          time: parseInt(index),
          commands: o
        }
      })
    })

    return commandsByType
  },
  convertCommandsToRoutineNew: (commandsList) => {

      var indexedCommands = [];
      var commandsByType = _.groupBy(commandsList, (o) => {
        if (!o.key) return;
        let key = o.key.split('.');
        let typeKey = o.key.split('.')[0]
        return typeKey
      })

      // get all commands by type
      for (var type in commandsByType) {
        if (commandsByType.hasOwnProperty(type)) {

          // 
          var indexArray = [];
          
          // create an indexArray with commands ordered by type
          commandsByType[type].forEach(routine => {
            var routineIndex = 0;
            if (routine.hasOwnProperty('channel')) {
              routineIndex = routine.channel
            } 
            if (!Array.isArray(indexArray[routineIndex])) {
              indexArray[routineIndex]= [];
            }
            indexArray[routineIndex].push(routine)
          })

          // convert the indexArray to an array of routines
          indexArray = indexArray.map(routines => {
            return _.map(_.groupBy(routines, 'time'), (o, index) => {
                return {
                  time: parseInt(index),
                  commands: o
                }
              })
          })

          commandsByType[type] = indexArray
        }
      }

    return commandsByType
  },
  deepEqual: function (a, b) {
    if ((typeof a === 'object' && a != null) &&
      (typeof b === 'object' && b != null)) {
      var count = [0, 0]
      for (var key in a) count[0]++
      for (var key in b) count[1]++
      if (count[0] - count[1] != 0) { return false }
      for (var key in a) {
        if (!(key in b) || !Helpers.deepEqual(a[key], b[key])) { return false }
      }
      for (var key in b) {
        if (!(key in a) || !Helpers.deepEqual(b[key], a[key])) { return false }
      }
      return true
    } else {
      return a === b
    }
  }
}

module.exports = Helpers



// WEBPACK FOOTER //
// ./js/common/helpers.js